import Link from "next/link";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { setCookieValue } from "@/app/utils/utility";
import { useSelector } from "react-redux";

export default function SignInModal({ isOpen, onOpenChange }) {
  const { items } = useSelector(state => state.cart.cartDetails);

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange} className="text-center">
      <DialogContent>
        <DialogHeader className="flex justify-center items-center">
          <DialogTitle className="text-2xl font-semibold">Sign in to your account</DialogTitle>
          <DialogDescription className="text-base text-gray-500 pb-3">
            To proceed with the purchase, you need to sign in.
          </DialogDescription>
          <Button size="lg" asChild>
            <Link href="/sign-in" className="w-full">
              Sign in
            </Link>
          </Button>
          <div className="flex gap-1 text-base pt-3">
            Don't have an account?{" "}
            <Link
              href="/sign-up"
              onClick={() => {
                if (items?.length > 0) {
                  setCookieValue("checkout-redirect-status", true);
                }
              }}
              className="text-blue-600 hover:underline"
            >
              Sign up
            </Link>
          </div>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
